import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Button from "./Button";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import loading from "../../img/loading.svg";
import TypesTags from "./TypesTags";

class FillModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      confirm: false,

      loading: false,
      loadingD: false,
      name: this.props.dayTemplate.name,
      selectedValues: this.props.slotTypes,
      startTime: null /* moment()
        .hours(6)
        .minutes(0),*/,
      endTime: null /*moment()
        .hours(7)
        .minutes(0)*/
    };
  }
  saveChange = async () => {
    const id = this.props.dayTemplate.id;
    const name = this.state.name;
    await this.props
      .updateTemplateMutation({
        variables: { id, name }
      })
      .then(() => {
        this.setState(
          {
            error: "",
            loading: false,
            selectedValues: this.props.slotTypes,
            startTime: null,
            endTime: null
          },
          () => {
            this.toggleModal(false);
            this.props.refetchTemplate();
          }
        );
      })
      .catch(e => {
        e.graphQLErrors.forEach(error => {
          if (error.code === 3010) {
            this.setState({ error: "Ce template existe déjà!", name: "" });
          }
        });
        this.setState({
          loading: false,
          name: this.props.dayTemplate.name
        });
        console.error("update name", e);
      });
  };
  handleSave = async () => {
    const hours = this.props.dayTemplate.hours;
    //hours exist-> override
    let startTime = this.state.startTime;
    let endTime = this.state.endTime;
    this.setState({
      loading: true
    });
    if (startTime !== null && endTime !== null) {
      while (startTime.isSameOrBefore(endTime, "minutes")) {
        let hourToReplace = null;
        hourToReplace = hours.find(h => {
          return h.time === startTime.format("H:mm");
        });

        const slotTypesIds = this.state.selectedValues.map(type => {
          return type.id;
        });

        if (hourToReplace) {
          //hour existe, upates
          const id = hourToReplace.id;
          await this.props
            .updateHourMutation({
              variables: { id, slotTypesIds }
            })
            .catch(e => {
              console.error("update hour", e);
            });
        } else {
          //hour does not exist, create

          const time = startTime.format("H:mm");
          const dayTemplateId = this.props.dayTemplate.id;
          //save hour
          await this.props
            .createHourMutation({
              variables: { time, dayTemplateId, slotTypesIds }
            })
            .catch(e => {
              console.error("createHourMutation: ", e);
            });
        }

        startTime.add(this.props.base, "minutes");
      }
    }
    this.saveChange();
  };

  toggleModal = deleted => {
    if (this.state.error.length > 0) {
      this.setState({
        loading: false
      });
    } else {
      if (deleted) {
        this.setState(
          {
            loading: false,
            selectedValues: this.props.slotTypes,
            startTime: null,
            endTime: null
          },
          () => {
            this.props.setSelectedOption(null);
            this.props.refetchTemplates();
          }
        );
      } else {
        this.setState(
          {
            loading: false,
            selectedValues: this.props.slotTypes,
            startTime: null,
            endTime: null
          },
          () => {
            this.props.refetchTemplate();
            this.props.toggleModal();
          }
        );
      }
    }
  };
  disabledHours = () => {
    let disabledHours = [];
    let start = 0;
    let end = this.props.maxTimeAdmin;
    while (start < this.props.minTimeAdmin) {
      disabledHours.push(start);
      start++;
    }
    while (end < 24) {
      disabledHours.push(end);
      end++;
    }

    return disabledHours;
    //return [0, 1, 2, 3, 4, 5, 22, 23];
  };
  handelTimePickerChange = value => {
    if (this.state.startTime === null) {
      value.minute(0);
    }
    this.setState({
      startTime: value,
      endTime: value
        .clone()
        .hour(value.hour() + 1)
        .minute(0)
    });
  };
  handelTimePickerEndChange = value => {
    this.setState({
      endTime: value
    });
  };
  handleSelectChange = values => {
    this.setState({
      selectedValues: values
    });
  };
  handleNameChange = event => {
    this.setState({
      name: event.target.value
    });
  };

  deleteTemplate = () => {
    const id = this.props.dayTemplate.id;
    this.setState({
      loadingD: true
    });

    this.props
      .deleteTemplateMutation({
        variables: { id }
      })
      .then(() => {
        this.setState({ loadingD: false, deleted: true }, () =>
          this.toggleModal(true)
        );
      })
      .catch(e => {
        this.setState({ loadingD: false, error: true });
        console.error("delete dempalte", e);
      });
  };
  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };
  render() {
    return (
      <div className={"modal " + (this.props.isModalOpen ? "is-active" : "")}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">
              <input
                className="input modal-card-title"
                style={{
                  flex: "none",
                  width: "60%"
                }}
                placeholder="nom du template"
                value={this.state.name}
                onChange={this.handleNameChange}
              />
            </p>
          </header>

          <section className="modal-card-body">
            {this.state.confirm ? (
              <div className="modal-slot-overlay ">
                <div className="modal-slot-overlay-content has-text-centered">
                  <h1 className="title">Êtes-vous sûr?</h1>
                  <p>
                    <Button
                      style={{
                        width: "100px"
                      }}
                      text="Retour"
                      onClick={this.toggleConfirm}
                    />
                    <Button
                      color="red"
                      text="Oui!"
                      onClick={this.deleteTemplate}
                      //  onClick={this.handleCancel}
                      style={{
                        width: "100px"
                      }}
                    />
                  </p>
                  {this.state.loadingD ? (
                    <figure className="image is-32x32">
                      <img alt="loading" src={loading} />
                    </figure>
                  ) : null}
                </div>
              </div>
            ) : null}

            <div className="field">
              <label className="label">Début:</label>
              <div className="control">
                <TimePicker
                  onChange={this.handelTimePickerChange}
                  hideDisabledOptions={true}
                  allowEmpty={false}
                  defaultValue={this.state.startTime}
                  value={this.state.startTime}
                  minuteStep={this.props.base}
                  showSecond={false}
                  disabledHours={this.disabledHours}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Fin (inclus):</label>
              <div className="control">
                <TimePicker
                  onChange={this.handelTimePickerEndChange}
                  hideDisabledOptions={true}
                  allowEmpty={false}
                  defaultValue={this.state.endTime}
                  value={this.state.endTime}
                  minuteStep={this.props.base}
                  showSecond={false}
                  disabledHours={this.disabledHours}
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Types:</label>
              <div className="control">
                <TypesTags
                  enableAll={true}
                  allSlotTypes={this.props.slotTypes}
                  handleTypeTagChange={this.handleSelectChange}
                />
              </div>
            </div>
          </section>
          <footer className="modal-card-foot">
            {this.state.loading ? (
              <figure className="image is-32x32">
                <img alt="loading" src={loading} />
              </figure>
            ) : null}
            <Button
              color="red"
              text={"Effacer " + this.state.name}
              onClick={this.toggleConfirm}
              style={{
                margin: "auto",
                marginLeft: 0
              }}
            />
            <p className="has-text-danger">{this.state.error}</p>
            <Button
              text="Retour"
              onClick={() => this.props.toggleModal(false)}
            />
            <Button
              color="#00893D"
              text="Sauvegarder"
              onClick={this.handleSave}
            />
          </footer>
        </div>
      </div>
    );
  }
}

const UPDATE_TEMPLATE_MUTATION = gql`
  mutation updateTemplateMutation($id: ID!, $name: String!) {
    updateDayTemplate(id: $id, name: $name) {
      id
    }
  }
`;
const CREATE_HOUR_MUTATION = gql`
  mutation CreateHour(
    $time: String!
    $dayTemplateId: ID
    $slotTypesIds: [ID!]
  ) {
    createHour(
      time: $time
      dayTemplateId: $dayTemplateId
      slotTypesIds: $slotTypesIds
    ) {
      id
      time
    }
  }
`;

const UPDATE_HOUR_MUTATION = gql`
  mutation UpdateHourMutation($id: ID!, $slotTypesIds: [ID!]) {
    updateHour(id: $id, slotTypesIds: $slotTypesIds) {
      id
    }
  }
`;
const DELETE_TEMPLATE = gql`
  mutation deleteTemplateMutation($id: ID!) {
    deleteDayTemplate(id: $id) {
      id
    }
  }
`;

export default compose(
  graphql(CREATE_HOUR_MUTATION, {
    name: "createHourMutation"
  }),
  graphql(DELETE_TEMPLATE, {
    name: "deleteTemplateMutation"
  }),
  graphql(UPDATE_HOUR_MUTATION, {
    name: "updateHourMutation"
  }),
  graphql(UPDATE_TEMPLATE_MUTATION, {
    name: "updateTemplateMutation"
  })
)(FillModal);



// WEBPACK FOOTER //
// ./src/components/utilities/FillModal.js